<template>
  <div class="flex flex-col flex-wrap w-full h-auto flex-grow min-h-most">
    <div class=" p-5 w-full h-auto">
      <slot name="head" />
    </div>
    <div class="flex flex-col flex-wrap flex-grow w-full h-auto aproe-bg min-h-min">
      <div class="flex flex-col-reverse flex-wrap w-full h-auto flex-grow">
        <div class="w-full p-2 h-auto md:min-h-full">
          <div class="w-full sm:w-5/6 mx-auto h-auto min-h-full sm:p-3 pt-0">
            <slot
              class="w-full min-w-max h-auto md:min-h-full"
              name="left"
            />
          </div>
        </div>
        <div class="w-full h-auto md:min-h-full">
          <div class="w-full border-t-2 border-b-2 border-white mx-auto h-auto min-h-full bg-light p-3 sm:px-16 bg-opacity-25 sm:flex sm:flex-col">
            <slot
              class="w-full min-w-max h-auto min-h-full"
              name="right"
            />
          </div>
        </div>
      </div>
      <footer-bar />
    </div>
  </div>
</template>
<script>
import FooterBar from '../../../components/FooterBar.vue'
export default {
  name: 'AproeLayout',
  components: { FooterBar },
}
</script>
<style scoped>
.min-h-most {
  min-height: calc(5/6 * 100%) !important;
}
.aproe-bg {
  background: url('../../../assets/aproe-quote-engine-bg-opt.jpg')
    center top no-repeat #525252 !important;
  background-size: cover !important;
}
</style>
